<template>
  <div>
    <v-expansion-panel v-model="opened">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <span v-if="candidateProfileCompleted">{{ $t('job-offer-apply-step0-detail-complete', language, { lang: langTranslationLabel }) }}</span>
            <span v-else>{{ $t('job-offer-apply-step0-detail', language, { lang: langTranslationLabel }) }}</span>
          </div>
        </template>
        <v-card class="mb-3">
          <v-container
            fluid
            :grid-list-lg="$vuetify.breakpoint.smAndDown"
            :grid-list-xl="$vuetify.breakpoint.mdAndUp"
            class="pa-3"
          >
            <v-layout align-center justify-center :wrap="$vuetify.breakpoint.xsOnly">
              <v-flex shrink>
                <v-progress-circular
                  :rotate="-90"
                  :size="96"
                  :width="16"
                  :value="profileCompletePercentage"
                  color="primary"
                >{{ profileCompletePercentage }}%</v-progress-circular>
              </v-flex>
              <v-flex>
                <ui-content>
                  <ul>
                    <li v-for="(field, index) in profileFieldToComplete" :key="index">
                      <span class="font-weight-bold mr-2">{{field.step}}</span>
                      {{field.field}}
                    </li>
                  </ul>
                </ui-content>
                <slot v-if="!candidateProfileCompleted"></slot>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import ProfileCompletionHelpers from '@/helpers/profile-completion'
import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export default {
  props: {
    profile: {
      type: Object,
      required: true
    },
    translation: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    forcedLanguage: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      profileCompletePercentage: 0,
      profileFieldToComplete: [],
      candidateProfileCompleted: false,
      opened: this.$route.query.expandCompletionPanel === "false" ? null : 0
    }
  },
  created() {
    let result

    if (this.type === Consts.PROFIL_PRO) {
      result = ProfileCompletionHelpers.getProfileProCompletion(this.profile, this.translation)
    } else if (this.type === Consts.PROFIL_STUDENT) {
      result = ProfileCompletionHelpers.getProfileStudentCompletion(this.profile, this.translation)
    } else {
      result = ProfileCompletionHelpers.getProfileCompletion(this.profile, this.translation)
    }

    this.profileCompletePercentage = result.profileCompletePercentage
    this.profileFieldToComplete = result.profileFieldToComplete
    this.candidateProfileCompleted = result.candidateProfileCompleted
  },
  computed: {
    langTranslationLabel: function() {
      return this.translation.language === Consts.CONTENT_LANGUAGE_FR
        ? i18n.instance().t('multilang-french-label')
        : i18n.instance().t('multilang-english-label')
    },
    language: function() {
      return this.forcedLanguage ? this.forcedLanguage : i18n.instance().locale
    }
  }
}
</script>